import React, { useState, useContext } from 'react';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { StoreContext } from '../../../store/Provider';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import './modal.css';

function ContactUs() {
    const context = useContext(StoreContext);
    const [openalert, setOpenalert] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [severity, setSeverity] = useState('error');
    const [message, setMessage] = useState('');
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenalert(false);
    };
    const onSend = () => {
        if (!message) {
            setOpenalert(true);
            setSeverity("error");
            setAlertText("Please enter message!");
        } else {
            window.location.href = `mailto:importops@mtsnyc.com?subject=MY MTS: Shipment ID - ${context.shipmentId}&body=${message}`
        }
    }

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    return (
        <div className="filterModeComponent mailComponent">
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={openalert} autoHideDuration={3000} onClose={handleClose}>
                <Alert severity={severity} onClose={handleClose}>{alertText}</Alert>
            </Snackbar>
            <div className="modalHeading">
                <h6>Contact Us</h6>
                <CloseIcon className="pointer" onClick={context.handleModalClose} />
            </div>
            <div className="filterModalBody">
                <div className="mailto">
                    <input className="form-control mailtoInput" type="text" value="To : importops@mtsnyc.com" disabled />
                </div>
                <div className="mailSender">
                    <input className="form-control mailSenderInput" type="text" value={`MY MTS: Shipment ID - ${context.shipmentId}`} disabled />
                </div>
                <div className="mailBoody">
                    <TextareaAutosize className="form-control" aria-label="minimum height" rowsMin={10} placeholder="Message" vaule={message} onChange={(e) => setMessage(e.target.value)} />
                </div>
            </div>
            <div className="modalFooter mt-3">
                <Button variant="contained" onClick={context.handleModalClose}>Cancel</Button>
                <Button variant="contained" onClick={() => onSend()}>Send Message</Button>
            </div>
        </div>
    )
}

export default ContactUs
